import gql from 'graphql-tag'

// NOTE: this mutation has a mixed-schema return type — the `DraftAudienceMember`
// fragment is registered in the fieldwork codegen schema, but the
// `deleteCustomAudienceTranslationV2` mutation field itself only exists on the
// questionnaire endpoint (it is NOT present in the fieldwork schema).
// Neither `fieldworkGql` nor `questionnaireGql` can validate both sides at
// once, so we fall back to plain `gql` from `graphql-tag`. At runtime the
// Apollo link routes the operation through `context.clientName === 'questionnaire'`.
// Same pattern as `UPDATE_AUDIENCE_MEMBER_V2`. If the fieldwork schema ever
// adds this mutation, swap to `fieldworkGql` for typed variables.
export const DELETE_CUSTOM_AUDIENCE_TRANSLATION = gql`
  mutation deleteCustomAudienceTranslationV2(
    $input: DeleteCustomAudienceTranslationV2ArgsInput!
  ) {
    deleteCustomAudienceTranslationV2(input: $input) {
      ...DraftAudienceMember
    }
  }
`
